import { AnalyticsEvent, type AllAnalyticsEvents } from '@shipt/analytics-member-web'
import { type OnAnalytics } from '@shipt/cdui-modules/analytics'
import { track } from '@/features/shared/analytics/trackingQueue'

/**
 * Bridges CDUI's platform-neutral event names to Segway's analytics SDK.
 * Unknown names are ignored instead of being sent as an invalid event when a
 * newer CDUI module reaches an older host build.
 */
export const trackCduiAnalytics: OnAnalytics = ({ name, properties }) => {
  const eventName = Object.entries(AnalyticsEvent).find(([key]) => key === name)?.[1]
  if (!eventName) return

  // oxlint-disable-next-line typescript/consistent-type-assertions -- CDUI deliberately carries the common runtime property bag; the analytics package models each event as a stricter discriminated union.
  track({ eventName, properties } as AllAnalyticsEvents)
}
